module.exports = __webpack_public_path__ + "img/kv_pc_02.b0876aec.jpg";